"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./FollowLoadingButton.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FollowLoadingButton = function FollowLoadingButton(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "loading-button__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "loading-button loading-button--".concat(size)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "loading-button__main"
  })));
};

var _default = FollowLoadingButton;
exports.default = _default;
//# sourceMappingURL=FollowLoadingButton.js.map